$(document).ready(function() {

	// autocomplete form functionality
	if ($('#autocomplete-form').length > 0) {
		autocomplete();
		initialSearchForm('monthly');
	}
	
	// block :: contact form :: subject cards 
	$('.cit-subject-card').on('click', function(event) {
		var input = $(this).attr('data-choice-id');
		$('#' + input).prop('checked', true);
	});

	// block :: frequently asked questions
	$('.cit-faqs-group').each(function(index, group) {
		$('.cit-faq-question', group).on('click', function() {
			$('.cit-faq-question', group).parent().removeClass('cit-faq-active');
			$(this).parent().addClass('cit-faq-active');
		});
	});
	
	// block :: testimonials
	$('.cit-testimonials-group').each(function(index, group) {
		var testimonials = $(group).flickity({
			adaptiveHeight: true,
			autoPlay: true,
			pageDots: true,
			percentPosition: true,
			prevNextButtons: false,
			wrapAround: true
		});
	});

});
